// Dynamic viewport units (dvh/dvw) are only supported from Chrome/WebView 108.
// Older browsers drop the whole declaration, which for inline styles means the
// property is simply not applied (e.g. form fields losing their 80dvw width and
// the layout height chain collapsing). CSS files handle this with a vh/vw
// fallback line above each dv declaration; inline styles can't hold two values
// for one property, so they go through dvSize() instead.
//
// On browsers that support dv units this returns the input untouched, so
// behavior there is byte-identical to the previous hardcoded values.

let dvUnitsSupported: boolean | undefined;

export const supportsDynamicViewportUnits = (): boolean => {
  if (dvUnitsSupported === undefined) {
    dvUnitsSupported =
      typeof CSS !== "undefined" &&
      typeof CSS.supports === "function" &&
      CSS.supports("height", "100dvh");
  }
  return dvUnitsSupported;
};

/** "80dvw" -> "80dvw" on modern browsers, "80vw" on browsers without dv units. */
export const dvSize = (value: string): string => {
  return supportsDynamicViewportUnits()
    ? value
    : value.replace(/(\d+)(?:d|s)v(h|w)/g, "$1v$2");
};
